import React from 'react';
import { useTheme } from 'styled-components';

export const WrenchSvg = (props) => {
  const { width, height, color, sketch } = props;

  const theme = useTheme();

  if (sketch) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27.989 19.977C27.367 19.977 26.764 20.055 26.183 20.19L15.811 9.818C15.945 9.237 16.023 8.634 16.023 8.012C16.023 3.587 12.436 0 8.012 0C7.11 0 5.91 0.916 6.909 1.915L9.906 4.912C9.906 4.912 10.905 6.91 8.907 8.907C6.909 10.904 4.911 9.905 4.911 9.905L1.915 6.909C0.916 5.91 0 7.105 0 8.012C0 12.437 3.587 16.024 8.012 16.024C8.634 16.024 9.237 15.946 9.818 15.812L20.189 26.183C20.054 26.764 19.976 27.367 19.976 27.989C19.976 32.414 23.564 36 27.988 36C28.889 36 30.089 35.084 29.09 34.085L26.093 31.088C26.093 31.088 25.094 29.09 27.092 27.093C29.09 25.096 31.087 26.094 31.087 26.094L34.084 29.091C35.084 30.09 36 28.895 36 27.989C36 23.564 32.413 19.977 27.989 19.977Z" fill="#8899A6" />
      </svg>
    )
  }

  return (
    <svg width={width ?? "18"} height={height ?? "18"} viewBox="0 0 18 18" fill={color ?? theme?.colour?.secondary ?? '#04333B'} xmlns="http://www.w3.org/2000/svg">
      <path d="M4.0055 9.9885C4.3165 9.9885 4.618 10.0275 4.9085 10.095L10.0945 4.909C10.0275 4.6185 9.9885 4.317 9.9885 4.006C9.9885 1.7935 11.782 0 13.994 0C14.445 0 15.045 0.458 14.5455 0.9575L13.047 2.456C13.047 2.456 12.5475 3.455 13.5465 4.4535C14.5455 5.452 15.5445 4.9525 15.5445 4.9525L17.0425 3.4545C17.542 2.955 18 3.5525 18 4.006C18 6.2185 16.2065 8.012 13.994 8.012C13.683 8.012 13.3815 7.973 13.091 7.906L7.9055 13.0915C7.973 13.382 8.012 13.6835 8.012 13.9945C8.012 16.207 6.218 18 4.006 18C3.5555 18 2.9555 17.542 3.455 17.0425L4.9535 15.544C4.9535 15.544 5.453 14.545 4.454 13.5465C3.455 12.548 2.4565 13.047 2.4565 13.047L0.958 14.5455C0.458 15.045 0 14.4475 0 13.9945C0 11.782 1.7935 9.9885 4.0055 9.9885Z" />
    </svg>
  )
}



